import React from 'react';
import Select from 'react-select';
import { useSelectStyles } from '../../utils/selectStyles';

const GIPlanningStatusFilter = ({ selectedStates, onChange }) => {
  const selectStyles = useSelectStyles();

  const stateOptions = [
    { value: 'Animé', label: '🟢 Animé' },
    { value: 'Annulé', label: '🔴 Annulé' },
    { value: 'Autre', label: '⚫ Autres statuts' },
    { value: 'En attente', label: '⏳ En attente' }
  ];

  return (
    <Select
      isMulti
      placeholder="Filtrer par statut..."
      options={stateOptions}
      value={stateOptions.filter(option => selectedStates.includes(option.value))}
      onChange={(selectedOptions) => {
        onChange(selectedOptions ? selectedOptions.map(option => option.value) : []);
      }}
      styles={selectStyles}
      className="text-sm"
      classNamePrefix="react-select"
      menuPortalTarget={document.body}
    />
  );
};

export default GIPlanningStatusFilter;


